module.exports = __webpack_public_path__ + "img/delta-to-delta-aux-trafo.d19298b9.svg";